import Marquee from "react-fast-marquee";

const WORDS = [
  "Land Clearing", "Mulching", "Material Delivery", "House Pads",
  "Grading", "Excavating", "Septic Install", "Culvert Install",
  "Shell Construction", "Concrete",
];

export const Ribbon = () => (
  <section id="marquee" data-testid="marquee" className="relative py-10 md:py-16 bg-brand-black border-y border-brand-concrete overflow-hidden">
    <Marquee speed={60} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className="font-anton uppercase text-6xl md:text-8xl text-stroke px-6 select-none">
            {w}
          </span>
          <span className="text-brand-red text-5xl md:text-7xl px-2">✦</span>
        </span>
      ))}
    </Marquee>
  </section>
);
